import { createContext } from 'react'

const linkedinContext = createContext()

export default linkedinContext
